import { render, staticRenderFns } from "./TeachingPaperDeptForm.vue?vue&type=template&id=f239c28c"
import script from "./TeachingPaperDeptForm.vue?vue&type=script&lang=js"
export * from "./TeachingPaperDeptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports